import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { webSocketUrl } from '../../config/Env';

import { Creators as pedidosActions } from '../../store/ducks/pedidos';
import { Creators as webSocketActions } from '../../store/ducks/websocket-connection';

let SECONDS = 1000;

const ID_STATUS_AGUARDANDO = 1,
    ID_STATUS_RECEBIDO = 2;

class WebsocketController extends Component {
    async componentDidMount() {
        const { user } = this.props,
            { token } = user || {};

        if (token !== null) {
            this.setupWebSocket(token);
        }
    }

    setupWebSocket = (token) => {
        let ws = new WebSocket(webSocketUrl);

        const { searchPedidos } = this.props;

        ws.onopen = async () => {
            console.log('WebSocket connected');

            this.props.connectWebsocket(true);

            setTimeout(() => {
                ws.send('open');
            }, 2000);
        };

        ws.onmessage = async (event) => {
            ws.send('');

            const idsBusca = `${ID_STATUS_AGUARDANDO},${ID_STATUS_RECEBIDO}`,
                location = document.location.pathname,
                { data } = event,
                { idPedido } = data ? JSON.parse(data) : {};

            if (idPedido && location === '/') {
                await searchPedidos({ idStatusPedido: idsBusca });
            }
        };

        ws.onclose = async () => {
            console.log('WebSocket disconnected');
            ws = null;

            this.props.connectWebsocket(false);

            setTimeout(() => {
                this.setupWebSocket(token);
            }, SECONDS);

            SECONDS = SECONDS + 2000;
        };

        ws.onerror = (err) => {
            console.error('Socket error: ', err.message, 'Closing socket');
            ws.close();
        };
    };

    render() {
        return <Fragment />;
    }
}

const mapStateToProps = ({ user }) => ({
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...pedidosActions, ...webSocketActions }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WebsocketController);
